module.exports = __webpack_public_path__ + "static/media/22ESCWA15.7c7a77ab.jpg";